export const NOTIFICATION = [
  {
    title: 'Delivery processing',
    time: 10 * 1000 * 60,
    fontColor: 'primary'
  },
  {
    title: 'Order Complete',
    time: 1 * 1000 * 60 * 60,
    fontColor: 'success'
  },
  {
    title: 'Tickets Generated',
    time: 3 * 1000 * 60 * 60,
    fontColor: 'info'
  },
  {
    title: 'Delivery Complete',
    time: 6 * 1000 * 60 * 60,
    fontColor: 'danger'
  },
];
